import classNames from "classnames";
import { customTypesAccessLevelsAgainstProfile } from "PFCore/helpers/custom_types";
import { CustomType, Profile } from "PFTypes";
import { useMemo } from "react";

import { useTargets } from "../../common/use_targets";
import { EditMode, OnProfileUpdateHandler, SetEditMode } from "../profile_show_page.types";
import { UseInterestsReturn } from "../query/use_interests";
import { ExpertiseField } from "./expertise_field";
import InterestsSection from "./interests_section";
import css from "./section_additional.module.scss";

type AdditionalSectionProps = {
  className?: string;
  me: boolean;
  isPendingUpdate: boolean;
  profile: Profile;
  currentProfile: Profile;
  experienceCustomTypes: CustomType[];
  interestsCollection: UseInterestsReturn;
  initSection?: string;
  handleProfileUpdate: OnProfileUpdateHandler;
  editMode: EditMode;
  setEditMode: SetEditMode;
};

const AdditionalSection = ({
  profile,
  me,
  currentProfile,
  handleProfileUpdate,
  isPendingUpdate,
  editMode,
  interestsCollection,
  setEditMode,
  experienceCustomTypes,
  initSection,
  className
}: AdditionalSectionProps) => {
  const { recalcTargets, updateHighlight } = useTargets({
    me,
    profile,
    initSection
  });

  const allowedExperienceCustomTypes = useMemo(() => {
    const accessLevels = customTypesAccessLevelsAgainstProfile(profile, currentProfile);

    return experienceCustomTypes.filter((item) => ["rw", "ro"].includes(accessLevels[item.id]));
  }, [currentProfile, profile, experienceCustomTypes]);

  const showInterests = interestsCollection?.isLoading || interestsCollection?.entries.length > 0;

  return (
    <div className={classNames(css.additional, className)}>
      {allowedExperienceCustomTypes?.map((customType) => (
        <ExpertiseField
          className={css.expertiseField}
          key={customType?.name}
          customType={customType}
          profile={profile}
          isMe={me}
          recalcTargets={recalcTargets}
          onProfileUpdate={handleProfileUpdate}
          isEditMode={editMode[`cf_${customType?.name}`]}
          onEditModeChange={() => setEditMode(`cf_${customType?.name}`, !editMode[`cf_${customType?.name}`])}
          isLoading={isPendingUpdate}
        />
      ))}
      {showInterests && (
        <InterestsSection
          className={css.expertiseField}
          updateHighlight={updateHighlight}
          interestsCollection={interestsCollection}
          profile={profile}
        />
      )}
    </div>
  );
};

export default AdditionalSection;
